class DeleteVehicleController {

  constructor ($scope, $rootScope) {
    'ngInject'
    this.$rootScope = $rootScope
    $scope.$on('deleteVehicle:close', () => {
      this.showDeleteBtn = false
    })
  }

  activeDeleteMode () {
    this.$rootScope.$broadcast('editVehicle:close')
    this.showDeleteBtn = !this.showDeleteBtn
  }

  handleSubmit () {
    this.onConfirm()
      .then(() => {
        this.showDeleteBtn = false
      })
  }

}

export default DeleteVehicleController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/delete-vehicle/delete-vehicle.controller.js